import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getReferralCode } from '@/modules/driver/store/selectors';
import { siteDomain } from '@/shared/utils/getSiteDomain';

import { ICard } from '../types';

const REFERRAL_CODE_KEY = 'referral-code';

const useReferralCard = (): ICard | undefined => {
  const intl = useIntl();
  const referralCode = useSelector(getReferralCode);

  if (!referralCode.code) {
    return undefined;
  }

  return {
    id: 'ref',
    cardStatus: 'todo' as const,
    title: intl.formatMessage({
      defaultMessage: 'Invite colleagues',
      id: '4pEOfu',
      description: 'todo list card text',
    }),
    desc: referralCode.description,
    actionTitle: intl.formatMessage({
      defaultMessage: 'Copy invite link',
      id: 'zXHMwP',
      description: 'todo list card text',
    }),
    action: () => {
      navigator.clipboard.writeText(
        siteDomain + `/chauffeur?${REFERRAL_CODE_KEY}=${referralCode.code}`,
      );
    },
  };
};

export { useReferralCard, REFERRAL_CODE_KEY };
